<template>
  <div class="loader">
    <div class="ico"></div>
    <div class="text" v-if="!isBack">
      <span v-if="!isCheckDone">Weryfikacja licznika...</span>
      <span v-if="isCheckDone && !isCalculationDone">Kalkulacja...</span>
      <span v-if="isCheckDone && isCalculationDone">Przetwarzanie danych...</span>
    </div>
    <div class="text" v-if="isBack">
      <span>Zaczekaj. Trwa&nbsp;weryfikacja&nbsp;płatności...</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'TopupLoader',
  props: ['isBack'],
  computed: {
    ...mapState({
      isCheckDone: state => state.energy.checkData !== null,
      isCalculationDone: state => state.energy.calculationData !== null
    })
  }
}
</script>
